import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fabubankuai: '',
    lunbotuxiangqing: {},
    shangxiehuixiangqing: 0,
    fabuID: 0,
    huodongID: 0,
    zhengceID: 0,
    huiyuanID: 0,
    shenfenID: 0,
    jubaoID: 0,
    yijianID: 0,
    rightList: JSON.parse(sessionStorage.getItem('rightList') || '[]'),
    quanxianID: 0
  },
  mutations: {
    setRightList (state, data) {
      state.rightList = data
      sessionStorage.setItem('rightList', JSON.stringify(data))
    },
    setFabubankuai (state, data) {
      state.fabubankuai = data
    },
    setlunbotuxiangqing (state, data) {
      state.lunbotuxiangqing = data
    },
    setshangxiehuixiangqing (state, data) {
      state.shangxiehuixiangqing = data
    },
    setfabuID (state, data) {
      state.fabuID = data
    },
    sethuodongID (state, data) {
      state.huodongID = data
    },
    setzhengceID (state, data) {
      state.zhengceID = data
    },
    sethuiyuanID (state, data) {
      state.huiyuanID = data
    },
    setshenfenID (state, data) {
      state.shenfenID = data
    },
    setjubaoID (state, data) {
      state.jubaoID = data
    },
    setyijianID (state, data) {
      state.yijianID = data
    },
    setquanxianID (state, data) {
      state.quanxianID = data
    }
  },
  actions: {
  },
  modules: {
  }
})
